/*
 * The preference boxes english translation
 */
export const PREFERENCES_BOX_EN = {
  preferences: 'Preferences',
  dyn: {
    PREFTYPE: {
      FORMAT: 'Format',
      FUNC: 'Function',
      STYLE: 'Style',
      LANG: 'Language'
    },
    STYLE: {
      easylanguage: 'Easy Language',
      advertising: 'Advertising',
      kundea: 'Kunde A',
      kundeb: 'Kunde B',
      kundec: 'Kunde C'
    },
    LANG: {
      english: 'English',
      german: 'German',
      italian: 'Italian',
      spanish: 'Spanish',
      hungarian: 'Hungarian',
      french: 'French'
    },
    INPUT_SOURCE: {
      input: 'Source',
      generated: 'Draft'
    }
  }
}
/*
 * The preference boxes german translation
 */
export const PREFERENCES_BOX_DE = {
  preferences: 'Einstellungen',
  dyn: {
    PREFTYPE: {
      FORMAT: 'Format',
      FUNC: 'Funktion',
      STYLE: 'Stil',
      LANG: 'Sprache'
    },
    STYLE: {
      easylanguage: 'Einfache Sprache',
      advertising: 'Werblich',
      // test styles
      kundea: 'Kunde A',
      kundeb: 'Kunde B',
      kundec: 'Kunde C'
    },
    LANG: {
      english: 'Englisch',
      german: 'Deutsch',
      italian: 'Italienisch',
      spanish: 'Spanisch',
      hungarian: 'Ungarisch',
      french: 'Französisch'
    },
    INPUT_SOURCE: {
      input: 'Quelle',
      generated: 'Entwurf'
    }
  }
}
